import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import StudentBar from "../students/StudentBar";
import SectionForm from "./SectionForm";
class Section extends Component {
    state = { isModal: false, loading: true, loadError: "", formData: null, sections: [], search: "" };

    componentDidMount() { this.getSections(); }

    getSections = async () => {
        this.setState({ loading: true, loadError: "" });
        try {
            const response = await axios.get("sections");
            this.setState({ sections: Array.isArray(response.data) ? response.data : [] });
        } catch (error) {
            this.setState({ loadError: "Impossible de charger le registre des sections." });
        } finally {
            this.setState({ loading: false });
        }
    };

    showModal = (section = null) => {
        this.setState((state) => ({ isModal: !state.isModal, formData: state.isModal ? null : section }), () => {
            if (!this.state.isModal) this.getSections();
        });
    };

    delete = async (section) => {
        const label = section.entitled_section || section.short_entitled_section || "cette section";
        if (!window.confirm(`Supprimer définitivement « ${label} » ?`)) return;
        try {
            const response = await axios.delete(`sections/${section.id}`);
            toast.success(response?.data?.msg || "La section a été supprimée.");
            this.getSections();
        } catch (error) {
            toast.error(error.response?.data?.msg || "La suppression a échoué.");
        }
    };

    handleCheck = (permission) => {
        try {
            const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
            return permissions.some((item) => permission === item.permission);
        } catch (error) { return false; }
    };

    getStudentCount = (section) => (section.sectionclasses || []).reduce(
        (total, sectionclass) => total + (sectionclass.students?.length || 0), 0
    );

    getYearLabel = (section) => section.year?.year || section.schoolyear?.year || section.scolary_year || "Année non précisée";

    renderSectionCard = (section) => {
        const classes = section.sectionclasses || [];
        const students = this.getStudentCount(section);
        const canEdit = this.handleCheck("Modifier section");
        const canDelete = this.handleCheck("Supprimer section");
        const code = section.short_entitled_section || "SEC";
        return <div className="col-md-6 col-xl-4" key={section.id}>
            <article className="school-section-card">
                <div className="school-section-card__header">
                    <span className="school-section-card__code">{code}</span>
                    <span className="school-section-card__status"><i />{section.status || "Active"}</span>
                </div>
                <div className="school-section-card__body">
                    <span className="school-section-card__eyebrow">Section scolaire</span>
                    <h3>{section.entitled_section || "Section sans intitulé"}</h3>
                    <p><FeatherIcon icon="calendar" size={14} />{this.getYearLabel(section)}</p>
                </div>
                <div className="school-section-card__metrics">
                    <span><strong>{classes.length}</strong>Classe{classes.length !== 1 ? "s" : ""}</span>
                    <span><strong>{students}</strong>Élève{students !== 1 ? "s" : ""}</span>
                </div>
                <div className="school-section-card__footer">
                    <div className="school-section-card__class-list" aria-label="Aperçu des classes">
                        {classes.length ? classes.slice(0, 3).map((item) => <span key={item.id}>
                            {`${item.class?.short_entitled_class || ""} ${item.title || ""}`.trim() || "Classe"}
                        </span>) : <em>Aucune classe rattachée</em>}
                        {classes.length > 3 && <b>+{classes.length - 3}</b>}
                    </div>
                    {(canEdit || canDelete) && <div className="school-section-card__actions">
                        {canEdit && <button type="button" onClick={() => this.showModal(section)} title="Modifier la section" aria-label={`Modifier ${section.entitled_section}`}><FeatherIcon icon="edit-3" size={15} /></button>}
                        {canDelete && <button type="button" className="is-danger" onClick={() => this.delete(section)} title="Supprimer la section" aria-label={`Supprimer ${section.entitled_section}`}><FeatherIcon icon="trash-2" size={15} /></button>}
                    </div>}
                </div>
            </article>
        </div>;
    };

    render() {
        const query = this.state.search.trim().toLocaleLowerCase("fr");
        const filteredSections = this.state.sections.filter((section) =>
            [section.entitled_section, section.short_entitled_section, this.getYearLabel(section)]
                .filter(Boolean).some((value) => String(value).toLocaleLowerCase("fr").includes(query))
        );
        const totalClasses = this.state.sections.reduce((total, section) => total + (section.sectionclasses?.length || 0), 0);
        const totalStudents = this.state.sections.reduce((total, section) => total + this.getStudentCount(section), 0);
        const labels = this.state.sections.map((section) => section.short_entitled_section || section.entitled_section);
        const chartData = this.state.sections.map(this.getStudentCount);

        return <main className="container school-sections-page">
            <Helmet><title>{process.env.REACT_APP_NAME} | Sections scolaires</title></Helmet>
            <header className="school-sections-header">
                <div className="school-sections-header__copy">
                    <span><FeatherIcon icon="layers" size={14} />Organisation académique</span>
                    <h1>Registre des sections</h1>
                    <p>Structurez les filières et options de l’établissement, puis suivez leurs classes et leurs effectifs.</p>
                </div>
                <div className="school-sections-header__actions">
                    <Link to="/manuel#sections" className="school-sections-guide"><FeatherIcon icon="book-open" size={17} />Doc</Link>
                    {this.handleCheck("Ajouter section") && <button type="button" className="school-sections-add" onClick={() => this.showModal(null)}><FeatherIcon icon="plus" size={18} />Nouvelle section</button>}
                </div>
            </header>

            <section className="school-sections-stats" aria-label="Résumé du registre">
                <article><span className="is-blue"><FeatherIcon icon="layers" size={20} /></span><div><strong>{this.state.sections.length}</strong><small>Sections actives</small></div></article>
                <article><span className="is-gold"><FeatherIcon icon="book-open" size={20} /></span><div><strong>{totalClasses}</strong><small>Classes rattachées</small></div></article>
                <article><span className="is-green"><FeatherIcon icon="users" size={20} /></span><div><strong>{totalStudents}</strong><small>Élèves inscrits</small></div></article>
            </section>

            <section className="school-sections-directory">
                <div className="school-sections-toolbar">
                    <div><span>Répertoire administratif</span><h2>Sections et options</h2></div>
                    <label className="school-sections-search">
                        <FeatherIcon icon="search" size={16} />
                        <input type="search" value={this.state.search} onChange={(event) => this.setState({ search: event.target.value })} placeholder="Rechercher une section…" aria-label="Rechercher une section" />
                        {this.state.search && <button type="button" onClick={() => this.setState({ search: "" })} aria-label="Effacer la recherche"><FeatherIcon icon="x" size={14} /></button>}
                    </label>
                </div>
                {this.state.loading ? <div className="school-sections-state"><FeatherIcon className="user-search-spin" icon="loader" /></div>
                    : this.state.loadError ? <div className="school-sections-state is-error"><FeatherIcon icon="alert-circle" size={28} /><h3>Registre indisponible</h3><p>{this.state.loadError}</p><button type="button" onClick={this.getSections}>Réessayer</button></div>
                    : filteredSections.length ? <div className="row g-3">{filteredSections.map(this.renderSectionCard)}</div>
                    : <div className="school-sections-state"><span><FeatherIcon icon={query ? "search" : "layers"} size={27} /></span><h3>{query ? "Aucun résultat" : "Le registre est vide"}</h3><p>{query ? "Essayez un autre intitulé ou une autre abréviation." : "Créez une première section pour organiser les classes de l’école."}</p></div>}
            </section>

            {!this.state.loading && !this.state.loadError && labels.length > 0 && <section className="school-sections-chart">
                <div className="school-sections-chart__heading"><span><FeatherIcon icon="bar-chart-2" size={18} /></span><div><small>Analyse des effectifs</small><h2>Élèves par section</h2></div></div>
                <StudentBar key={`${labels.join("|")}-${chartData.join("|")}`} data={chartData} labels={labels} title="Les élèves par section" />
            </section>}
            <SectionForm isModal={this.state.isModal} formData={this.state.formData} showModal={this.showModal} />
        </main>;
    }
}

export default Section;
